import React, { useState } from 'react';
import {
    Box,
    Chip,
    Menu,
    Slider,
} from '@mui/material';
import { trakrefFontFamilySemiBold } from '../../../utils';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PropTypes from 'prop-types';

const chipStyle = {
    '&.MuiChip-root': { borderRadius: 0, backgroundColor: '#fff', border: '1px solid #E3E8EB' },
    '&.MuiChip-label': { fontFamily: trakrefFontFamilySemiBold }
};

const ChipSlider = ({
    id,
    disabled,
    label,
    value,
    onChange,
    step,
    marks,
    min,
    max,
    abbreviation,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    return (
        <>
            <Chip
                label={value ? `${label}: ${value[0]}${abbreviation} - ${value[1]}${abbreviation}` : label}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                onDelete={(e) => setAnchorEl(e.currentTarget)}
                deleteIcon={<KeyboardArrowDownIcon />}
                variant="outlined"
                disabled={disabled}
                id={id}
                sx={{...chipStyle}}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                PaperProps={{  
                    style: {
                        width: 300,
                        height: 'auto',
                        maxHeight: 300,
                    }
                }}
            >
                <Box sx={{ p: 2, width: 300 }}>
                    <Slider
                        marks={marks}
                        getAriaLabel={() => label}
                        value={value}
                        onChange={(e, newVal) => onChange(newVal)}
                        valueLabelDisplay="auto"
                        step={step}
                        min={min}
                        max={max}
                        sx={{ marginTop: '6%', marginBottom: '-6%' }}
                    />
                </Box>
            </Menu>
        </>
    );
};

ChipSlider.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    step: PropTypes.number,
    marks: PropTypes.bool,
    disabled: PropTypes.bool,
    showNullOption: PropTypes.bool,
    id: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    abbreviation: PropTypes.string,
};

ChipSlider.defaultProps = {
    required: false,
    disabled: false,
    showNullOption: false,
    id: "",
    step: 10,
    marks: true,
    min: 0,
    max: 100,
    abbreviation: "",
};

export default ChipSlider;